import React from 'react';
import { Button, InputGroup, Form } from 'react-bootstrap';
import Conect from '../../../../Api/Conect';
import NotificationsAlert from '../../../services/NotificationsAlert';
import './EditHodoStyles.css';

const ModalEditHodo = ({ isOpen, onClose, getPositions, token, odometer, setOdometer, idVehicle }) => {

    const sendingAttHodo = async () => {
        const response = await Conect.post(`/YXR0b2RvbWV0ZXI=${token}`, {
            id_vehicle: idVehicle,
            new_hodometer: odometer,
        })
        if (response.data.erro === true) {
            NotificationsAlert("warning", "Atenção", response.data.msg)
        }
        else {
            getPositions()
            NotificationsAlert("warning", "Atenção", "Comando cadastrado com sucesso!")
        }
    }

    const renderButton = (label, onClick, variant = 'primary', extraStyles = {}) => (
        <Button
            className="btns-block"
            variant={variant}
            style={{
                marginTop: '3%',
                width: '30%',
                borderRadius: '20px',
                ...extraStyles,
            }}
            onClick={onClick}
        >
            {label}
        </Button>
    );

    return (
        isOpen && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <h3>Calibração de Hodometro.</h3>
                    <InputGroup style={{ marginBottom: '2%', marginTop: '3%' }}>
                        <InputGroup.Text className='input-text-edit-hodo'>Hodômetro: </InputGroup.Text>
                        <Form.Control className='form-modal-edit-hodo' value={odometer} onChange={(e) => setOdometer(e.target.value)} />
                    </InputGroup>
                    <div className="modal-actions">
                        {renderButton('Cancelar', onClose, 'secondary', { position: 'absolute', left: '15%' })}
                        {renderButton('Confirmar', sendingAttHodo, 'primary', { position: 'absolute', right: '15%' })}
                    </div>
                </div>
            </div>
        )
    );
};

export default ModalEditHodo;
